import { ColumnDef } from '@tanstack/react-table';
import { formatTableTimestamp } from '../../utils/formatTableDate';
import {
  SortableHeader,
  TruncatedCell,
  DownloadedCheckmark,
} from '@/components';
import { AdditionalRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createAdditionalRecordsColumns =
  (): ColumnDef<AdditionalRecord>[] => [
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) =>
        row.original.name ? (
          <TruncatedCell text={row.original.name} />
        ) : (
          'No data available'
        ),
    },
    {
      accessorKey: 'classificationType',
      header: 'Classification',
      cell: ({ row }) =>
        row.original.classificationType ||
        row.original.category ||
        'No data available',
    },
    {
      id: 'dateUploaded',
      accessorFn: (row) => row.createdAt,
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date Uploaded</SortableHeader>
      ),
      cell: ({ row }) => formatTableTimestamp(row.original.createdAt),
    },
    {
      accessorKey: 'sourceType',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Source Type</SortableHeader>
      ),
      cell: ({ row }) => row.original.sourceType || 'No data available',
    },
    {
      id: 'markedDownloaded',
      enableSorting: false,
      header: '',
      cell: ({ row }) =>
        row.original.markedDownloaded ? <DownloadedCheckmark /> : null,
    },
    {
      id: 'actions',
      enableSorting: false,
      header: '',
      cell: ({ row }) => (
        <div className="flex items-center justify-end gap-1">
          <PatientDocumentViewButton
            disabled={
              !row.original.sourceType || !row.original.classificationType
            }
            documentKey={{
              source: DocumentSource.MEDICAL_RECORDS,
              type: DocumentType.ADDITIONAL,
              additionalRecordId: row.original.id,
              classificationType: row.original.classificationType,
              sourceType: row.original.sourceType,
              name: row.original.name,
            }}
          />
        </div>
      ),
    },
  ];
